// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PortCallSchedule\PortCallScheduleResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { PortCallRights } from 'server/enums/Rights';

// PortCallScheduleResponseData is the class that PortCallScheduleResponse serializes to/from
export interface PortCallScheduleResponseData {
    Id : number;
	
    PortCall : PortCallData | null;
	
    Rights : PortCallRights;
}

// PortCallScheduleResponseOptions is the class which may be passed to the PortCallScheduleResponse constructor to define optional initial data values
export interface PortCallScheduleResponseOptions {
    Id : number;
	
    PortCall? : PortCallOptions | null;
	
    Rights? : PortCallRights;
}

export class PortCallScheduleResponse {
    public Id : DataSignal<number>;
	
    public PortCall : DataSignal<PortCall | null>;
	
    public Rights : DataSignal<PortCallRights>;

    constructor();
    constructor(data : PortCallScheduleResponseOptions);
    constructor(data: PortCallScheduleResponseOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.PortCall = S.value<PortCall | null>(null);
	    
        this.Rights = jsonableObservable(S.value<PortCallRights>(data && data.Rights !== undefined ? data.Rights : 0));
    }

    static key(obj : PortCallScheduleResponse) {
        return obj.Id();
    }
    
    static dataKey(obj : PortCallScheduleResponseOptions) {
        return obj.Id;
    }

    static update(obj : PortCallScheduleResponse, data : PortCallScheduleResponseOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.Rights !== undefined) obj.Rights(data.Rights);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PortCallScheduleResponse.ts